<template>
  <div
    class="card-case"
    @click="clickCase"
  >
    <figure class="card-case__image">
      <slot name="image" />
    </figure>

    <!-- Title -->
    <div class="card-case__title">
      <slot name="title" />
    </div>

    <!-- Subtitle -->
    <div class="card-case__subtitle">
      <slot name="subtitle" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardCase',

  methods: {
    clickCase() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/card/card-case-view.scss"></style>



// WEBPACK FOOTER //
// card-case-view.vue